import classnames from 'classnames'
import * as React from 'react'

import { Button } from '../button'
import { Icon } from '../icon'
import { Heading } from '../typography'
import { DialogDragContext } from './hooks'

interface DialogHeaderProps {
  /**
   * Callback when user clicks on close button. The button will be hidden if not set
   */
  onCloseClick?: () => void

  /**
   * Additional class names for the component
   */
  className?: string
}

/**
 * Component which renders title and a close button
 */
export function DialogHeader({ onCloseClick, children, className }: React.PropsWithChildren<DialogHeaderProps>) {
  const dialogDrag = React.useContext(DialogDragContext)

  return (
    <div
      ref={dialogDrag.handleRef}
      className={classnames(
        className,
        'flex h-12 shrink-0 select-none items-center justify-between border-b border-gray-100 px-4 dark:border-gray-600',
        { 'cursor-grab active:cursor-grabbing': dialogDrag.enabled }
      )}
    >
      {children && <Heading level={4}>{children}</Heading>}
      {onCloseClick && (
        <Button
          className="mr-0 ml-auto"
          theme="opacity"
          appearance="square"
          onClick={onCloseClick}
          data-testid="dialog-button-close"
        >
          <Icon name="close" width={24} />
        </Button>
      )}
    </div>
  )
}
